import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";

import SupportCaseModel from "models/SupportCaseModel";
import { initialResultsDtoModel, ResultsDtoModel } from 'models/ResultsDtoModel';
import SearchTransactionDto from 'models/SearchTransactionDto';

import { getAuthorizedApi, processAxiosError, urlBuilder } from "services/common.service";
import { setResultsDtoBase } from "reducers/dto.slice";


export const getSupportCases = createAsyncThunk('case/getSupportCases',
    async (searchDto: SearchTransactionDto, { dispatch }) => {
        try {
            const url = urlBuilder('/SupportCases/GetSupportCases', searchDto);

            const response = await getAuthorizedApi().get<ResultsDtoModel<SupportCaseModel>>(url);

            const data = response.data;

            dispatch(setResultsDtoBase({
                totalResults: data.totalResults,
                offset: data.offset,
                page: data.page
            }));

            return data;
        } catch (err) {
            const error = err as AxiosError;
            processAxiosError(error, dispatch);
        }
        return initialResultsDtoModel;
    });